export { Link } from "@chakra-ui/react";
const baseStyle = ({ colorScheme })=>{
    let color = `${colorScheme}.500`;
    if (colorScheme === 'neutral') {
        color = 'inherit';
    }
    return {
        transitionProperty: 'common',
        transitionDuration: 'fast',
        transitionTimingFunction: 'ease-out',
        cursor: 'pointer',
        textDecoration: 'none',
        outline: 'none',
        color,
        _hover: {
            textDecoration: 'underline'
        },
        _focus: {
            textDecoration: 'underline',
            boxShadow: 'none'
        },
        _focusVisible: {
            outlineOffset: '1px',
            outline: '1px solid',
            textDecoration: 'none'
        }
    };
};
const variants = {
    deezer: {
        color: 'text.accent.primary.default',
        _hover: {
            color: 'text.accent.primary.hovered',
            textDecoration: 'none'
        },
        _focus: {
            textDecoration: 'underline'
        },
        _focusVisible: {
            textDecoration: 'underline',
            outline: 'none'
        }
    },
    navlink: {
        color: 'text.neutral.primary.default',
        _active: {
            color: 'text.accent.primary.hovered'
        },
        _hover: {
            color: 'primary.700',
            textDecoration: 'none'
        },
        _focus: {
            textDecoration: 'underline'
        },
        _focusVisible: {
            textDecoration: 'underline',
            outline: 'none'
        }
    }
};
export const ThemedLink = {
    baseStyle,
    variants,
    defaultProps: {
        colorScheme: 'neutral'
    }
};

//# sourceMappingURL=Link.js.map